export default __webpack_public_path__ + "eb085166caf70f41ebdba66529d50e64.woff2";